import { propertyDamageType } from "../constants/propertyDamageType";

export const propertyDamage = (data) => ({
  type: propertyDamageType.POST_PROPERTY_DAMAGE_PENDING,
  data,
});

export const propertyDamageSuccess = (data) => ({
  type: propertyDamageType.POST_PROPERTY_DAMAGE_SUCCESS,
  data,
});

export const propertyDamageFailure = (error) => ({
  type: propertyDamageType.POST_PROPERTY_DAMAGE_FAILURE,
  error,
});

export const getPropertyDamage = (caseid, incidentid) => ({
  type: propertyDamageType.GET_PROPERTY_DAMAGE_PENDING,
  caseid,
  incidentid,
});

export const getPropertyDamageSuccess = (data) => ({
  type: propertyDamageType.GET_PROPERTY_DAMAGE_SUCCESS,
  data,
});

export const getPropertyDamageFailure = (error) => ({
  type: propertyDamageType.GET_PROPERTY_DAMAGE_FAILURE,
  error,
});

export const updatePropertyDamage = (data) => ({
  type: propertyDamageType.PUT_PROPERTY_DAMAGE_PENDING,
  data,
});

export const updatePropertyDamageSuccess = (data) => ({
  type: propertyDamageType.PUT_PROPERTY_DAMAGE_SUCCESS,
  data,
});

export const updatePropertyDamageFailure = (error) => ({
  type: propertyDamageType.PUT_PROPERTY_DAMAGE_FAILURE,
  error,
});

export const clearPropertyDamage = () => ({
  type: propertyDamageType.CLEAR_PROPERTY_DAMAGE,
  data: "",
});

export const clearPropertyDamages = () => ({
  type: propertyDamageType.CLEAR_PROPERTY_DAMAGES,
  data: "",
});
